export default {"src":"https://cdn.tanzhi.cn/_next/static/media/upload.c8c91ed1.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};